/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import { peekPerson } from '@linc-technologies/linced-common/utils/load-people';
import type Amount from 'linced-app/models/finance/daily-summary/amount';
import type Person from 'linced-app/models/person';

// Proto: finance.DailySummaryTillUser.
export default class TillUser extends Fragment {
  declare [Type]: 'finance/daily-summary/till-user';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  // person reads the till user's person from the store. It does not load it.
  // The controller that shows the daily summaries must load the till users
  // first (loadPeople).
  get person() {
    if (isEmpty(this.personId)) {
      return null;
    }
    return peekPerson<Person>(
      this.store,
      this.personId,
      'Load the till users before the report shows (loadPeople).',
    );
  }

  @fragmentArray('finance/daily-summary/amount')
  declare totals: FragmentArray<Amount>;

  @computed('totals.@each.amount')
  get total() {
    if (isEmpty(this.totals)) {
      return 0;
    }
    return this.totals.reduce((total, { amount }) => {
      return total + amount;
    }, 0);
  }
}
